import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker with auto-update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', {
      // Force browser to check for SW updates on every page load
      updateViaCache: 'none'
    }).then((registration) => {
      // Check for updates every 60 seconds while app is open
      setInterval(() => {
        registration.update();
      }, 60 * 1000);

      // When a new service worker is waiting, activate it
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              // New version activated — reload to get fresh content
              window.location.reload();
            }
          });
        }
      });
    }).catch(() => {});

    // Listen for messages from the service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'SW_UPDATED') {
        // Service worker updated — reload the page
        window.location.reload();
      }
    });
  });
}
